import { FeatureFlags } from 'src/types';

export const featureFlags = (window.featureFlags || {}) as FeatureFlags;
